import { CLEAR_ALL, LOGOUT } from '../../store/Types';

export const ALL_TELEFONOS = 'ALL_TELEFONOS';
export const LOADING_ALL_TELEFONOS = 'LOADING_ALL_TELEFONOS';
export const ACTIVO_TELEFONOS = 'ACTIVO_TELEFONOS';
export const PARAMS_TELEFONOS = 'PARAMS_TELEFONOS';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const telefonosReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_TELEFONOS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_TELEFONOS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_TELEFONOS:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_TELEFONOS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
